import React, { useEffect, useState }             from 'react'
import {
  Box, Button, Container,
  FormControl, Grid, Input,
  InputLabel, Paper,
}                                                 from '@mui/material'
import { useTranslation }                         from 'react-i18next'
import { useNavigate, useParams }                 from 'react-router-dom'
import { useApi }                                 from '../utils/api'
import { useSnackbar }                            from 'notistack'
import AlertSimpleDialog                          from '../ui/components/alert-simple-dialog'
import Page                                       from '../ui/components/Page'
import { BaseBreadcrumbs }                        from '../ui/components/BaseBreadcrumbs'
export default function CategoryPage() {

  const api = useApi()
  const navigate = useNavigate()
  const { categoryId } = useParams()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()
  const [values, setValues] = useState({
    name: '',
  })
  const [shownDeleteDialog, setShownDeleteDialog] = useState(false)

  useEffect(() => {
    (async () => {
      if (!isNaN(categoryId)) {
        try{
          let category = await api.category.detail(categoryId)
          setValues({
            name: '',
            ...category
          })
        } catch (e){
          enqueueSnackbar(t('Can\'t load category'), {
            variant: "error"
          })
        }
      }
    })()
  }, [categoryId])

  const handleChange = (prop) => (event) => {
    setValues({ ...values, [prop]: event.target.value })
  }

  const handleCloseDeleteDialog = (result) => {
    setShownDeleteDialog(false)
    if (result) {
      api.category.delete(categoryId).then(() => {
        enqueueSnackbar(t('Category deleted'), {
          variant: 'success'
        })
        navigate('/categories')
      }).catch(error => {
        enqueueSnackbar(t('Failed to delete category'), {
          variant: 'error'
        })
      })
    }
  }

  const onSubmit = async (e) => {
    e.preventDefault()
    let data = { ...values }
    try {
      let category = await api.category.save(data)
      navigate(`/categories/${category.id}`)
      enqueueSnackbar(t('Category saved'), {
        variant: 'success'
      })
    } catch (e) {
      enqueueSnackbar(t('Failed to save category'), {
        variant: 'error'
      })
    }
  }

  return (
    <Page title={t('Category')}>
      <Container component="main">
        <BaseBreadcrumbs key={'breadcrumb-category'}
                         title={values?.name ?? t('Category')}
                         items={[{ title: t('Categories'), href: `/categories` }]}
        />
        <Grid component={'form'} onSubmit={onSubmit} item xs={12}>
          <Paper sx={{ p: 2, width: '100%' }}>
            <Grid container sx={{ width: '100%' }} spacing={2}>
              <Grid item xs={12}>
                <FormControl fullWidth variant="standard">
                  <InputLabel htmlFor="user-name">{t('Name')}</InputLabel>
                  <Input
                    id="user-name"
                    value={values.name}
                    onChange={handleChange('name')}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Paper>
          <Box sx={{ mt: 2, px: 1 }}>
            <Button type={'submit'} variant={'contained'}>{t('Save')}</Button>
            { !isNaN(categoryId) && (<Button type={'button'} color={'error'} variant={'contained'} sx={{ ml: 2 }} onClick={() => { setShownDeleteDialog(true) }}>{t('Delete')}</Button>) }
          </Box>
        </Grid>
        <AlertSimpleDialog
          title={t('Deleting category')}
          message={t('delete-confirm-msg', { name: values.name })}
          open={shownDeleteDialog}
          onClose={handleCloseDeleteDialog}
        />
      </Container>
    </Page>
  )
}